import React from "react";
import Header from "../../components/header/Header";
import UpperHeader from "../../components/header/UpperHeader";
import Footer from "../../components/footer/Footer";
import SelfIntroduce from "../../components/self_introduce/SelfIntroduce";

const Members: React.FC = () => {
  return (
    <div>
      <Header pageTitle="メンバー紹介"></Header>
      <UpperHeader></UpperHeader>

      <SelfIntroduce
        name_ja="吉田 真人"
        name_en="Yoshida Masato"
        college="生物学類３年"
        word="やってみなくちゃわからない、iGEM TSUKUBAで！"
        picture="pages\about_us\Members\YoshidaMasato.webp"
        alt="Yoshida Masato"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="富田 朔矢"
        name_en="Tomida Sakuya"
        college="物理学類３年"
        word="人生には八つの坂があるなんて言いますが"
        picture="pages\about_us\Members\TomidaSakuya.webp"
        alt="Tomida Sakuya"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="阿萬 遥奈"
        name_en="Ama Haruna"
        college="生物学類２年"
        word="Jamboreeに行かないと成仏できない"
        picture="pages\about_us\Members\AmaHaruna.webp"
        alt="Ama Haruna"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="豊田 莉々"
        name_en="Toyoda Riri"
        college="生物学類２年"
        word="カマキリの捕食シーンが大好きです。"
        picture="pages\about_us\Members\ToyodaRiri.webp"
        alt="Toyoda Riri"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="樋野 遥"
        name_en="Hino Haruka"
        college="生物学類２年"
        word="よろしくお願いします。"
        picture="pages\about_us\Members\HinoHaruka.webp"
        alt="Hino Haruka"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="遠藤 勇志"
        name_en="Endo Yushi"
        college="生物資源学類２年"
        word="続・メタ認知"
        picture="pages\about_us\Members\EndoYushi.webp"
        alt="Endo Yushi"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="大井 空羽"
        name_en="Oi Soraha"
        college="生物学類２年"
        word="がんばります！"
        picture="pages\about_us\Members\OiSoraha.webp"
        alt="Oi Soraha"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="紙谷 啓佑"
        name_en="Kamitani Keisuke"
        college="総合学域３類１年"
        word="力になれるように頑張ります！"
        picture="pages\about_us\Members\KamitaniKeisuke.webp"
        alt="Kamitani Keisuke"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="八木 善成"
        name_en="Yagi Yoshinari"
        college="総合学域群第３類１年"
        word="この文章を読んだ君はiGEMに入ろう。全然関係ないけど総学は人生最大のモラトリアムだと思う。"
        picture="pages\about_us\Members\YagiYoshinari.webp"
        alt="Yagi Yoshinari"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="山本 悠人"
        name_en="Yamamoto Yuto"
        college="知識情報・図書館学類１年"
        word="科学研究とAIが大好きです。頑張ります！"
        picture="pages\about_us\Members\YamamotoYuto.webp"
        alt="Yamamoto Yuto"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="宇原 聡太"
        name_en="Uhara Sota"
        college="応用理工学類１年"
        word="好きな国:イタリア クロアチア アルゼンチン よろしくお願いします！"
        picture="pages\about_us\Members\UharaSota.webp"
        alt="Uhara Sota"
        under_bar={true}
      ></SelfIntroduce>

      <SelfIntroduce
        name_ja="MT"
        name_en="MT"
        college="生物学類１年"
        word="生物学初心者です"
        picture="pages\about_us\Members\MT.webp"
        alt="MT"
        under_bar={true}
      ></SelfIntroduce>

      <Footer></Footer>
    </div>
  );
};

export default Members;
